import React, { Component } from 'react';
import store from '~/redux/user/store';
import { checkPassword, setParentalControls, updateRating } from '~/redux/user/actions';
import { setParentalControlToggle } from '~/components/ToggleSwitch/setParentalControlToggle'
import Spinner from '~/components/Spinner';
import './style.scss'
import userStore from '~/redux/user/store'
import popup from '~/views/Popup/popup';
import { fbLogin } from '~/redux/user/actions'
import { get } from 'lodash'
import socialHelpers from '../socialHelpers'
import { getLocalizedVal } from '~/tools/localization/helpers'

class PasswordAuth extends Component {
    constructor(props){
        super(props)
        this.state = {
            error: '',
            user_password: '',
            pinSetupSuccess: '',
            metaDataMap: {}
        }
    }
    componentDidMount(){
        socialHelpers.initializeFacebookLogin()

    }
    getVal(key){
        return get(this.state.metaDataMap, key)
    }

    shouldDisableLogin() {
        if (this.state.buttonProgress)
          return true
    
        return false
    }

    handlePassword = (event) => {
        const { name, value } = event.target;
        this.setState({[name]: value});
    }

    saveViewingRestriction = async (viewingRestrictionRating) => {
        const userRating = {
            "parentalRating": viewingRestrictionRating
        }
        await setParentalControls(userRating)
        .then(response => { 
            if (response && response.status === 200) {
                store.dispatch(updateRating(viewingRestrictionRating))
                popup.hide()
            } else {
                this.alert(getLocalizedVal(window.settings,'genericMessages','unableSetPin') || 'Unable to set the PIN' || response.data.error);
                return false;
            }
        })
    }

    closePopup = () => {
        setTimeout(()=> { popup.hide() }, 2000)
    }

    passwordVerification = async (event) => {
        await event.preventDefault()

        if(!this.state.user_password || this.state.user_password.length < 4) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','enterCorrectPassword') || 'Enter correct password');
            return false;
        } else {    
            this.setState({ processing: true });
            const user = store.getState().user;

            var checkPasswordCreds = {
                email: user && user.email,
                password: this.state.user_password
            }
            
            checkPassword(checkPasswordCreds)
            .then(passwordRes => {
                if (passwordRes && passwordRes.status === 200) {
                    const getToggleFlag = this.props && this.props.args && this.props.args.parentalControlToogle;
                    
                    if(getToggleFlag) {
                        if(setParentalControlToggle(getToggleFlag)) {
                            this.props.args.updateParentalControlToogle();
                            this.setState({ processing: false });
                            popup.hide();
                        } else {
                            this.alert(getLocalizedVal(window.settings,'genericMessages','unableDisableParental') || "Unable to disable parental control");
                            this.setState({ processing: false });
                        }  
                    } else {
                        const getViewingRating = this.props && this.props.args && this.props.args.rating;
                        
                        if(getViewingRating) {
                            this.saveViewingRestriction(getViewingRating);
                            this.setState({ processing: false, pinSetupSuccess: true})
                        } else {
                            this.alert(getLocalizedVal(window.settings,'genericMessages','unableSetRestriction') || 'Unable to set Viewing restriction');
                            this.setState({ processing: false})
                        }
                    }
                    
                } else {
                    this.setState({ processing: false });
                    this.alert(getLocalizedVal(window.settings,'genericMessages','enterCorrectPassword') || 'Enter correct password' || passwordRes.data.error);
                }
                return false;  
            })
        }
    }

    facebookLogin(e) {
        const element = document.getElementById('ageCheck')
        if(element){
          const ageCheck = element.checked
          if (!ageCheck){
            this.setState({ageCheckError:window.settings.features.legal_verbiage_error})
            return
          }
        }
        window.FB.login( res => {
          var accessToken = res && res.authResponse && res.authResponse.accessToken
          if (!accessToken)
            return this.alert(this.getVal('facebookError'))
          this.dispatchLogin(fbLogin({
            facebookToken: accessToken,
            emailConsent: (this.state.activeTab === 'signup' && this.state.emailConsent.visible) ? this.state.emailChecked : undefined
          }), 'Facebook')
        }, { auth_type: 'reauthenticate' })
      }
      dispatchLogin(act, loginType) {
        if(this.props.onInitiate){ this.props.onInitiate('login') }
        userStore
          .dispatch(act)
          .then( _ => {
            const getToggleFlag = this.props && this.props.args && this.props.args.parentalControlToogle;
                    
            if(getToggleFlag) {
                if(setParentalControlToggle(getToggleFlag)) {
                    popup.hide();
                    this.props.args.updateParentalControlToogle();
                    this.setState({ buttonProgress: false });
                } else {
                    this.alert(getLocalizedVal(window.settings,'genericMessages','unableDisableParental') || "Unable to disable parental control");
                    this.setState({ buttonProgress: false });
                }  
            } else {
                const getViewingRating = this.props && this.props.args && this.props.args.rating;
                if(getViewingRating) {
                    popup.hide();
                    this.saveViewingRestriction(this.props.args.rating);
                    window.location = '/user';
                    this.setState({ buttonProgress: false, pinSetupSuccess: true})
                } else {
                    this.setState({ buttonProgress: false, pinSetupSuccess: false})
                }
            }
          })
          .catch( error => {
            var errorCode = ""
            this.setState({ buttonProgress: false })
            if(error.response && error.response.data) {
              errorCode = error.response.data.code
            }
            var message = this.getVal(errorCode) || this.getVal('defaultError') ;
            this.alert(message)
            if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
          })
      }
    
    alert(msg) {
        this.setState({ error: msg })
        setTimeout(_ => this.setState({ error: null }), 5000)
    }
    
    render() {
        const localizedArgs = this.props && this.props.args && this.props.args.localizedFields;
        const shouldDisableLogin = this.shouldDisableLogin()
        const { provider } = this.props.user;
        if (this.state.pinSetupSuccess) {
            return (
                <div className="centered padded">
                <h2>{ localizedArgs && localizedArgs.viewingRestrictionsSavedMsg || "Viewing Restrictions saved successfully."}</h2>
                { this.closePopup() }
                </div>
            )
        }

        return (
            <div className="centered padded">
                {this.state.error && <div className="error padding-bottom-20" >{this.state.error}</div>}
                
                {this.state.processing && <div className="loading-centered"><Spinner /></div>}
                {provider === 'facebook' ? 
                    <div>
                        <div className="social-logins">
                            <div className="social-buttons">
                                <button
                                    disabled={shouldDisableLogin}
                                    className="facebook-color-background button fat"
                                    onClick={e => this.facebookLogin(e)}
                                >{localizedArgs && localizedArgs.authWithFacebook || 'Authenticate With Facebook'}
                                </button><br />
                                {get(window.settings, 'socialMedia.googlePlus.signin') &&
                                <button
                                    disabled={shouldDisableLogin}
                                    className="google-color-background button fat"
                                    ref={el => this.googleButtonEl = el}
                                >
                                    {localizedArgs && localizedArgs.authWithGoogle || 'Authenticate With Google'}
                                </button>
                                }
                            </div>
                        </div>
                    </div>
                    : <div>
                        <h3>{localizedArgs && localizedArgs.enterPasswordLabel || "ENTER PASSWORD"}</h3>
                        <div>
                            <input className="input-width" type="password" id="user_password" name="user_password" onChange={event => this.handlePassword(event)} placeholder="" autoFocus required />
                        </div>
                        <div>
                            <input className={`input` + (this.state.processing ? ' processing' : '')} type="submit" value="SAVE" onClick={(event) => this.passwordVerification(event)} />
                        </div>
                    </div>
                }
            </div>

        );
    }
}

export default PasswordAuth;